import HintMessage from './HintMessage.component';

export default HintMessage;